<section class="pt-3">
  <screen-support></screen-support>  
</section>


<section class="sfe-safe pt-5 sfe-welcome">
  <div class="welcome-text">
    <h1 class="sfe-welcome-head">Business Assessment Summary</h1>
    <p>
      This section is a current business Health Score, and outputs action items into your Action Item List, intended to improve your business health.
      View your scores out of total possible points, to determine a strategy. Below are action summaries for each category. Action Items have been added to your business 
      Action Plan to begin implementing and improving your business, or business idea, where needed.
    </p>
  </div>
  <div class="sfe-welcome-img">

  </div>

 </section>

<nav aria-label="breadcrumb" class="pt-5 ">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active">
      <div *ngIf="authService.isAdmin == false">
            <a routerLink="/entrep-dash">Dashboard</a>
          </div>
          <div *ngIf="authService.isAdmin == true">
            <a routerLink="/admin-dash">Dashboard</a>
        </div>
    </li>
   
    <li class="breadcrumb-item active" aria-current="page">Business Results</li>
  </ol>
</nav> 

<ng-template #pending>
  <div class="mat-spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<section  class="sfe-safe" *ngIf="show">
  <div id="element-to-export">
    
   <div id="zdex" *ngIf="!pendingData else pending" >
    
    <article class="pt-5 pb-2" >
      <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
          <mat-card class="sfe-card">
            <mat-card-title-group>
                <mat-card-title>
                    Action Items Added 
                    <p>Take Action!</p>
                </mat-card-title>
                <mat-card-subtitle>
                   <!--something-->
                </mat-card-subtitle>
               <mat-icon class="icon-size">track_changes</mat-icon>
            </mat-card-title-group>
            <mat-card-content>
              <br/>
              <div [ngClass]="{'show-less': showTxtDescription}" >
                <p > 
                  The following Action Items have been added to your Action Plan based on your assessment results.  
                  <a type="button"  color="primary" routerLink="/action-plan">View Plan
                </a>    
              </p>
              <br/>
                <ul>
                  <li *ngFor="let action of assessmentPayload?.businessAssessmentActionItems">
                     {{action}}
                  </li>
                </ul>
                 
               
                </div>
                <div class="pt-2"></div>
              </mat-card-content>
              <mat-divider inset></mat-divider>
                <mat-card-actions>
                    <button mat-button (click)="showTxt()">{{ showTxtDescription ? 'READ MORE': 'READ LESS' }}</button>
                </mat-card-actions>
          </mat-card>
      </div>
    </article>
    
    <article class="pt-5 white-bg" >
      <div class="container-fluid">
          
          <div class="sfe">
              <h2>Business Details</h2>
              <div class="table-responsive pt-2">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Business Name</th>
                      <th scope="col">Owner Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Telephone</th>
                    </tr>
                  </thead>
                  <tr>
                    <td>{{data?.busiName}}</td>
                    <td>{{data?.busiFirstName}} {{data?.busiLastName}}</td>
                    <td>{{data?.busiEmail}}</td>
                    <td>{{data?.busiTelephone}}</td>
                  </tr>
                  
                </table>
              </div>
            </div>
          </div>
        <div class="pb-5"></div>
      </article>
      <article class="pt-5 sfe"> 
        <div class="row">
            
          <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
            <mat-card class="sfe-card">
            
                <mat-card-title-group>
                      <mat-card-title>
                        <h1 class="teal">
                          {{assessmentPayload?.overallSustainibleScore?.overallSustainiblePercentage*100 | number:'1.0-0'}}%
                        </h1>
                      </mat-card-title>
                      <mat-card-subtitle>Overall Sustainible Score</mat-card-subtitle>
                      <img class="card-img-top img-fluid"  src="../../../assets/imgs/Strategy.png" alt="Strategy">
                  </mat-card-title-group>
              <mat-card-content>
               
                  <h3 class="teal">What is your overall Sustainability?</h3>
                <div [ngClass]="{'show-less': showShortSustScoreDescription}">
                    <div>
                    Congrats on taking your Sustainible Assessment! Your Overall Sustainible Score is {{assessmentPayload?.overallSustainibleScore?.overallSustainiblePercentage*100 | number:'1.0-0'}}/100 Sustainibility Score.
                    This score relates to your business idea and current operations.   
                    View the sub-scores of these factors below. And take next steps in your action plan to increase your score, business sustainability and likelihood of success!
                    </div>
               </div>
          </mat-card-content>
          <mat-divider inset></mat-divider>
              <mat-card-actions>
                <button mat-button (click)="sustScoreText()">{{ showShortSustScoreDescription ? 'READ MORE': 'READ LESS' }}</button>
              </mat-card-actions>
            </mat-card>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
            <mat-card class="sfe-card">
            
                <mat-card-title-group>
                      <mat-card-title>
                        <h1 class="teal">
                          {{assessmentPayload?.overallModelScore?.overallModelPercentage*100 | number:'1.0-0'}}%
                        </h1>
                      </mat-card-title>
                      <mat-card-subtitle>Overall Model Score</mat-card-subtitle>
                      <img class="card-img-top img-fluid"  src="../../../assets/imgs/Strategy.png" alt="Strategy">
                  </mat-card-title-group>
              <mat-card-content>
                  <h3 class="teal">How is your business model?</h3>
                <div [ngClass]="{'show-less': showShortModelScoreDescription}">
                    <div>
                     Your Business Model Score is {{assessmentPayload?.overallModelScore?.overallModelPercentage*100 | number:'1.0-0'}}/100. It scores the health of your business as a concept and high level idea. 
                     Your target customer, business competitiveness, industry strategy and team (or self) dynamics make up this score.
                    </div>
               </div>
          </mat-card-content>
          <mat-divider inset></mat-divider>
              <mat-card-actions>
                <button mat-button (click)="modelScoreText()">{{ showShortModelScoreDescription ? 'READ MORE': 'READ LESS' }}</button>
              </mat-card-actions>
            </mat-card>
          </div>
<!--Overall Operations Score-->
          <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
            <mat-card class="sfe-card">
                <mat-card-title-group>
                  <mat-card-title>
                    <h1 class="teal">
                      {{assessmentPayload?.overallOperatingScore?.overallOperatingPercentage*100 | number:'1.0-0'}}%
                    </h1>
                  </mat-card-title>
                  <mat-card-subtitle>Overall Operations Score</mat-card-subtitle>
                  <img class="card-img-top img-fluid"  src="../../../assets/imgs/Finance.png" alt="Finance">
                </mat-card-title-group>
                <mat-card-content>
                  <h3 class="teal">How are your overall operations?</h3>
                <div [ngClass]="{'show-less': showShortOperatingScoreDescription}">
                    <div>
                     Your Operations Score is {{assessmentPayload?.overallOperatingScore?.overallOperatingPercentage*100 | number:'1.0-0'}}/100. This scores the health of your current business operations and execution. 
                     Your execution of strategy and planning, marketing, legal, finance, operations and team make up this score.
                    </div>
                </div>
          </mat-card-content>
          <mat-divider inset></mat-divider>
              <mat-card-actions>
                <button mat-button (click)="operatingScoreText()">{{ showShortOperatingScoreDescription ? 'READ MORE': 'READ LESS' }}</button>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>
            <div class="row">
              <!--Business Strategy Model-->
              <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                <mat-card class="sfe-card">
                    <mat-card-title-group>
                          <mat-card-title>
                            <h1 class="teal">
                              {{assessmentPayload?.strategyModelScore?.strategyModelPercentage*10 | number:'1.0-0'}}/10
                             
                            </h1>
                          </mat-card-title>
                          <mat-card-subtitle>Strategy Model</mat-card-subtitle>
                          <img class="card-img-top img-fluid"  src="../../../assets/imgs/Strategy.png" alt="Strategy">
                      </mat-card-title-group>
                  <mat-card-content>
                      <h3 class="teal">How is your business model strategy?</h3>
                    <div [ngClass]="{'show-less': showShortModelStratDesciption}">
                      <!--Differentiation-->
                        <div *ngIf="assessmentPayload?.offerDifferentiationArray?.offerDiffScore > 1; else offerDiffScoreElse" >
                          <p>{{data?.busiName}} is different from competitors in {{assessmentPayload?.offerDifferentiationArray?.offerDifferentiationNameArray}}. 
                           Great {{data?.offerType?.name}} differentiation! <b>Hone in on these elements in your marketing.</b>
                            Ex. As a social media strategy, you can highlight each of these features in a post. 
                            To get started with marketing plans and enhance execution, HubSpot features some tools <a href="https://blog.hubspot.com/marketing/social-media-calendar-tools"
                            target="_blank" rel="noopener noreferrer">here.</a></p>
                        </div>
                        <ng-template #offerDiffScoreElse>
                          <p>{{data?.busiName}} is different from competitors in {{assessmentPayload?.offerDifferentiationArray?.offerDifferentiationNameArray}}. 
                          When {{data?.offerType?.name}}s aren't much different from others, competition can be heavy and retaining
                            customers can be hard. <b>Try to differentiate your {{data?.offerType?.name}} in more areas.</b> Here is an
                            article, <a href="https://www.departmentofproduct.com/blog/how-to-differentiate-your-product/"
                              target="_blank" rel="noopener noreferrer">How to Differentiate Your Product</a>, by the Department of Product may help spark
                            some ideas.</p>
                        </ng-template> 
                        <!--Supplier Power-->
                        <div *ngIf="data?.offerSupplierPower?.name == 'Moderately easy' || data?.offerSupplierPower?.name == 'Extremely easy'; else offerSupplierPowerSecond">
                         <p>
                          {{data?.busiName}}'s rated it ‘{{data?.offerSupplierPower?.name}}’ to switch suppliers if needed,
                              which can be a good sign. The power that suppliers have over a business 
                              can affect business progress and profit potential. Keep this in mind when looking for additional suppliers.
                            </p>
                            </div>
                        <ng-template #offerSupplierPowerSecond>
                          <ng-container *ngIf="1 == data?.offerSupplierPower?.value; else offerSupplierPowerThird">
                            <p> {{data?.busiName}}'s rated it 
                              ‘{{data?.offerSupplierPower?.name}}’ to switch suppliers if needed. The power that suppliers have over a business 
                                  can affect business progress and profit potential. So, <b>try to  diversify suppliers 
                                  or expand your supply options</b>. 
                                </p>
                          </ng-container>
                        </ng-template>
                        <ng-template #offerSupplierPowerThird>
                          <ng-container *ngIf="data?.offerSupplierPower?.name == 'I don`t need suppliers'">
                            <p>
                            {{data?.busiName}} doesn't need suppliers to operate.
                           </p>
                          </ng-container>
                        </ng-template>
                    <!--Competitiveness-->
                    <div *ngIf="data?.knownCompetition?.value == 3; else knownCompetitionElse">
                      <p>
                        {{data?.busiName}} states it doesn't have many known competitors. Industry unsaturation may allow {{data?.busiName}} a better chance of capturing the market. 
                        So, <b>develop a strategy to capture your market.</b> <a href="https://blog.hubspot.com/marketing/social-media-calendar-tools"
                        target="_blank" rel="noopener noreferrer"> How to Capture Market Share Through the Understanding of Consumer Needs</a> provides a starting point list. 
                      </p>
                    </div>
                    <ng-template #knownCompetitionElse>
                      <p>
                      {{data?.busiName}} has {{data?.knownCompetition?.name}} of known competitors. Saturated markets have 
                      heavy competition, making it harder to retain or get customers. <b>To stand out to customers, 
                      differentiate your {{data?.offerType?.name}} more.</b>
                      </p>
                    </ng-template>
              </div>
              </mat-card-content>
              <mat-divider inset></mat-divider>
                  <mat-card-actions>
                    <button mat-button (click)="stratModelText()">{{ showShortModelStratDesciption ? 'READ MORE': 'READ LESS' }}</button>
                  </mat-card-actions>
                </mat-card>
              </div>
              <!--Business Strategy Implementation-->
              <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                <mat-card class="sfe-card">
                
                    <mat-card-title-group>
                          <mat-card-title>
                            <h1 class="teal">
                              {{assessmentPayload?.strategyOperatingScore?.strategyOperationPercentage*10 | number:'1.0-0'}}/10
                            </h1>
                          </mat-card-title>
                          <mat-card-subtitle>Strategy Implementation</mat-card-subtitle>
                          <img class="card-img-top img-fluid"  src="../../../assets/imgs/Strategy.png" alt="Strategy">
                      </mat-card-title-group>
                  <mat-card-content>
                      <h3 class="teal">How is your strategy implementation going?</h3>
                    <div [ngClass]="{'show-less': showShortOperationsStratDesciption}">
                      <!--Business Plan-->
                      <div *ngIf="assessmentPayload?.busiPlanArray?.busiPlanWorkOnNameArray?.length > 0; else businessPlanElse">
                        <p>
                        {{data?.busiName}} needs to work on the following segments in their business plan:  {{assessmentPayload?.busiPlanArray?.busiPlanWorkOnNameArray}}.
                        You can use <a href="https://sustainibleapi.web.app/business-plan"
                        target="_blank" rel="noopener noreferrer">Sustainible's Business Plan Builder</a> to work on it.
                      </p>
                      </div>
                      <ng-template #businessPlanElse>
                      {{data?.busiName}}'s business plan is in good shape!
                      </ng-template>
                    <!--Barriers Overcome-->
                        <div *ngIf="assessmentPayload?.barriersLeftToOvercome?.barriersLeftToOvercomeNameArray?.length > 0; else barriersOvercomeElse">
                          {{data?.busiName}} needs to overcome the following industry barriers:  {{assessmentPayload?.barriersLeftToOvercome?.barriersLeftToOvercomeNameArray}}.
                        </div>
                        <ng-template #businessPlanElse>
                        {{data?.busiName}}'s has overcome the majority of industry barriers. Great job!
                        </ng-template>
              </div>
              </mat-card-content>
              <mat-divider inset></mat-divider>
                  <mat-card-actions>
                    <button mat-button (click)="stratOperationsText()">{{ showShortOperationsStratDesciption ? 'READ MORE': 'READ LESS' }}</button>
                  </mat-card-actions>
                </mat-card>
              </div>
              </div>
              <div class ="row">
                <!--Target Market Strategy-->
                <!--TODO-->
                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="purple-txt">
                            {{assessmentPayload?.modelMarketingScore?.marketingModelPercentage*10 | number:'1.0-0'}}/10 
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Marketing Model</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/Marketing.png" alt="Marketing">
                      </mat-card-title-group>
                      <mat-card-content>
                 <h3 class="purple-txt">How is your target market strategy?</h3>
                <div [ngClass]="{'show-less': showShortModelMarketingDesciption}">
                  <!--Business Target Customer-->
                  <!--B2B-->
                  <div *ngIf="1 >= assessmentPayload?.modelB2BTargetCustomer?.offerB2BTargetUserInputTotal && assessmentPayload?.modelB2BTargetCustomer?.offerB2BTargetUserInputTotal !== null; else offerB2BTargetSecond">
                   <p> {{data?.busiName}} sells to businesses who are of a specific: {{assessmentPayload?.modelB2BTargetCustomer?.offerB2BTargetNameArray}}.
                    Hone in on your target business customer more to help develop more effective marketing strategies.
                   </p>
                  </div>
                  <ng-template #offerB2BTargetSecond> 
                    <ng-container *ngIf="assessmentPayload?.modelB2BTargetCustomer?.offerB2BTargetUserInputTotal >= 2 && assessmentPayload?.modelB2BTargetCustomer?.offerB2BTargetUserInputTotal !== null">
                      <p> {{data?.busiName}} sells to businesses who are of a specific: {{assessmentPayload?.modelB2BTargetCustomer?.offerB2BTargetNameArray}}.
                        Use these specifics to create and implement marketing strategies. 
                      </p>
                  </ng-container>
                  </ng-template>
                  <!--B2C-->
                  <div *ngIf="1 >= assessmentPayload?.modelB2CTargetCustomer?.offerB2CTargetUserInputTotal && assessmentPayload?.modelB2CTargetCustomer?.offerB2CTargetUserInputTotal !== null; else offerB2CTargetSecond">
                    <p> {{data?.busiName}} sells to consumers who are of a specific: {{assessmentPayload?.modelB2CTargetCustomer?.offerB2CTargetNameArray}}.
                     Hone in on your target business customer more to help develop more effective marketing strategies.
                    </p>
                   </div>
                   <ng-template #offerB2CTargetSecond> 
                    <ng-container *ngIf="assessmentPayload?.modelB2CTargetCustomer?.offerB2CTargetUserInputTotal >= 2 && assessmentPayload?.modelB2CTargetCustomer?.offerB2CTargetUserInputTotal !== null">
                      <p>
                      {{data?.busiName}} sells to consumers who are of a specific: {{assessmentPayload?.modelB2CTargetCustomer?.offerB2CTargetNameArray}}.
                       Use these specifics to create and implement marketing strategies. 
                     </p>
                  </ng-container>
                  </ng-template>
                   <div>
                    <b>Satisfying Consumer Demand</b>
                    <div>
                      <p>
                        Consumers are dissatisfied in the areas of: {{assessmentPayload?.pmfCompetitorDissatisfactionNameArray?.pmfCompetitorDissatisfactionNameArray}}.
                       <br><span class="swotText">Strength: </span>{{data?.busiName}} solves consumer needs in the areas of: {{assessmentPayload?.offerDifferentiationArray?.offerDifferentiationNameArray}}.
                      </p>
                     </div>
                     <div *ngIf="assessmentPayload?.pmfSolveNeedRate?.dissatisfactionNotSolved.length > 0">
                        <p>
                          <span class="swotText">Weakness: </span>Competitor's customers are dissatisfied in certain areas,
                          but {{data?.busiName}} doesn't address some of those areas. This could signal similar customer dissatisfaction in these areas for 
                          {{data?.busiName}}. <b>Consider addressing these areas for your business: {{assessmentPayload?.pmfSolveNeedRate?.dissatisfactionNotSolvedNameArray}}  </b>
                       </p>
                     </div>
                    <ng-container *ngIf="assessmentPayload?.pmfSolveNeedRate?.dissatisfactionNotSolvedNameArray?.length == 0 || assessmentPayload?.pmfSolveNeedRate?.dissatisfactionNotSolvedNameArray?.length == null; else pmfSolveNeedRateSecond">
                      <p>
                        <span class="swotText">Strength: </span> {{data?.busiName}}'s solution satisfies existing consumer dissatisfaction at a high rate, signaling 
                        potential demand.
                      </p>
                    </ng-container>
                     <p>
                      <span class="swotText">Threat: </span>If {{data?.busiName}}'s {{data?.offerType?.name}} isn’t differentiated by much or doesn’t continue to innovate - and competitors see the {{data?.offerType?.name}} 
                        is attracting more customers - some may copy {{data?.busiName}} and competition can increase. <b>Continue to innovate to overcome this threat</b>.
                      </p>
                    <ng-container *ngIf="assessmentPayload?.pmfCompetitorDissatisfactionNameArray?.pmfCompetitorDissatisfactionNameArray == 'None of the above'">
                      <p>
                        <span class="swotText">Threat: </span> {{data?.busiName}}'s competitors are leaving consumers satisfied. This could increase market 
                        barriers to entry if consumers are loyal to competitor brands.
                      </p>
                      <p>
                        <span class="swotText">Opportunity: </span> There can be an opportunity to differentiate {{data?.busiName}} further or diversify 
                        the target market demographics.
                      </p>
                    </ng-container>
                    <ng-container *ngIf="'Product' == data?.offerType?.name; else mvpService">
                      <p>
                       The best way to determine Product Market Fit, as mentioned above, is to ask your customer directly through primary market research.
                       Below are some resources that you can access to create and execute Product Market Fit research:
                        <li> Step 1: <a href="https://youtu.be/0P7nCmln7PM" target="_blank" rel="noopener noreferrer">Learn how to create a minimally viable product</a> </li> 
                        <li> Step 2: Create consumer surveys for feedback. Tools:<a href="https://docs.google.com/forms" target="_blank" rel="noopener noreferrer"> Google Forms </a> or <a href="https://www.surveymonkey.com/user/sign-up/?ut_source=pricing_page" target="_blank" rel="noopener noreferrer">Survey Monkey </a> </li>
                        <li> Step 3: Analyze Your Data and refine your {{data?.offerType?.name}} </li>
                      </p>
                    </ng-container>
                    <ng-template #mvpService> 
                      <ng-container *ngIf="'Service' == data?.offerType?.name; else pmfBoth">
                        <p>
                          The best way to determine if a customer wants your service, is to ask your customer directly through primary market research.
                          Below are some resources that you can access to create and execute Product Market Fit research:
                           <li>Secondary Market Reserach: You can use <a href="https://ads.google.com/home/tools/keyword-planner/" target="_blank" rel="noopener noreferrer">Google’s Keyword Planner</a> and <a href="https://moz.com/explorer" target="_blank" rel="noopener noreferrer">Moz’s Keyword Explorer</a> to see how many potential customers are searching for services in your area. </li> 
                           <li>Primary Market Research: Ask some potential customers for feedback on your service idea. Create consumer surveys for feedback. Tools:<a href="https://docs.google.com/forms" target="_blank" rel="noopener noreferrer"> Google Forms </a> or <a href="https://www.surveymonkey.com/user/sign-up/?ut_source=pricing_page" target="_blank" rel="noopener noreferrer">Survey Monkey </a> </li>
                           <li>Put it into action: Analyze Your Data and refine your {{data?.offerType?.name}} </li>
                       </p>
                    </ng-container>
                    </ng-template>
                    <ng-template #pmfBoth>
                      <p>
                        <b>For {{data?.busiName}}'s Product</b>
                        The best way to determine if a customer wants your product, is to ask your customer directly through primary market research.
                        Below are some resources that you can access to create and execute Product Market Fit research:
                         <li> Step 1: <a href="https://youtu.be/0P7nCmln7PM" target="_blank" rel="noopener noreferrer">Learn how to create a minimally viable product</a> </li> 
                         <li> Step 2: Create consumer surveys for feedback. Tools:<a href="https://docs.google.com/forms" target="_blank" rel="noopener noreferrer"> Google Forms </a> or <a href="https://www.surveymonkey.com/user/sign-up/?ut_source=pricing_page" target="_blank" rel="noopener noreferrer">Survey Monkey </a> </li>
                         <li> Step 3: Analyze Your Data and refine your {{data?.offerType?.name}} </li>
                       </p>
                      <p>
                        <b>For {{data?.busiName}}'s Service</b>
                        The best way to determine  if a customer wants your service, is to ask your customer directly through primary market research.
                        Below are some resources that you can access to create and execute Product Market Fit research:
                         <li>Secondary Market Reserach: You can use <a href="https://ads.google.com/home/tools/keyword-planner/" target="_blank" rel="noopener noreferrer">Google’s Keyword Planner</a> and <a href="https://moz.com/explorer" target="_blank" rel="noopener noreferrer">Moz’s Keyword Explorer</a> to see how many potential customers are searching for services in your area. </li> 
                         <li>Primary Market Research: Ask some potential customers for feedback on your service idea. Create consumer surveys for feedback. Tools:<a href="https://docs.google.com/forms" target="_blank" rel="noopener noreferrer"> Google Forms </a> or <a href="https://www.surveymonkey.com/user/sign-up/?ut_source=pricing_page" target="_blank" rel="noopener noreferrer">Survey Monkey </a> </li>
                         <li>Put it into action: Analyze Your Data and refine your {{data?.offerType?.name}} </li>
                     </p>
                  </ng-template>
                  </div>
                      </div>
                </mat-card-content>
                <mat-divider inset></mat-divider>
                    <mat-card-actions>
                      <button mat-button (click)="marketingModelText()">{{ showShortModelMarketingDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions>
                  </mat-card>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="purple-txt">
                            {{assessmentPayload?.marketingOperatingScore?.marketingOperatingPercentage*10 | number:'1.0-0'}}/10 
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Marketing Implementation</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/Marketing.png" alt="Marketing">
                      </mat-card-title-group>
                      <mat-card-content>
                        <h3 class="purple-txt">How is marketing implementation going?</h3>
                      <div [ngClass]="{'show-less': showShortOperationsMarketingDesciption}">
                        <!--Marketing Website-->
                      <ng-container *ngIf="3 == data?.marketingWebsite?.value; else marketingWebsitesecond">
                        <p>
                        {{data?.busiName}} has a website.
                      </p>
                      </ng-container>
                      <ng-template #marketingWebsitesecond><!--how to optimize where can say 1 or 2-->
                        <ng-container *ngIf="2 == data?.marketingWebsite?.value || 1 == data?.marketingWebsite?.value; else marketingWebsitethird">
                          <p>
                          {{data?.busiName}} has a website, but it needs work in sales and traffic strategy. 
                          </p>
                        </ng-container>
                      </ng-template>
                      <ng-template #marketingWebsitethird> 
                        <ng-container *ngIf="0 == data?.marketingWebsite?.value">
                          <p>
                          {{data?.busiName}} doesn't have a website. When ready, you can DIY with tools like <a href="https://www.wix.com/"
                        target="_blank"  rel="noopener noreferrer">WIX</a> or <a href="https://khphotographix.com/"
                        target="_blank"  rel="noopener noreferrer">hire a web developer to assist</a>. 
                        </p>
                      </ng-container>
                      </ng-template>
                      <!--Marketing Brand-->
                      <div *ngIf="2 ==  data?.marketingBrand?.value; else marketingBrandElse"> 
                        <p>
                        {{data?.busiName}} has a consistent and professional brand. Great job!
                        </p>
                      </div>
                      <ng-template #marketingBrandElse>
                        <p>
                        {{data?.busiName}} needs a consistent and professional brand.
                        </p>
                      </ng-template>
                          <!--Marketing Effectiveness-->
                        <div *ngIf="data?.marketingEffectiveness?.value >= 2; else marketingEffectElse "> 
                          <p>
                          {{data?.busiName}} has and understands marketing strategies.
                          </p>
                        </div> 
                          <ng-template #marketingEffectElse>
                          <p>
                            {{data?.busiName}} needs marketing assistance and training.
                          </p>
                        </ng-template>
                          <!--Marketing Network-->
                          <div *ngIf="data?.marketingNetworkMaterial?.value == 3; else marketingNetworkMaterialSecond "> 
                            <p>
                            {{data?.busiName}} has effective marketing material for networking. Great job, continue to update it
                            and stay up to date on the latest trends.
                         </p>
                          </div>
                          <ng-template #marketingNetworkMaterialSecond>
                            <ng-container *ngIf="2 == data?.marketingWebsite?.value; else marketingNetworkMaterialThird">
                              <p>
                              {{data?.busiName}} has marketing material for networking but it needs to be updated.
                           </p>
                            </ng-container>
                          </ng-template>
                          <ng-template #marketingNetworkMaterialThird>
                            <p>
                            {{data?.busiName}} needs marketing material for networking. Marketing material helps display information 
                            about your business so you don't have to. This can help scale your operations and get in front of your target audience. 
                            Choose which marketing material is best for your business: flyers, business cards, QR codes, etc. Our Marketing Builder is coming soon. 
                            </p>
                          </ng-template>  
                     <!--Marketing Social Media-->
                     <div *ngIf="data?.marketingSocialMedia?.value == 3; else marketingSocialMediaSecond "> 
                      <p>
                      {{data?.busiName}}'s social media platform is a major business driver. Great job! Continue to engage customers in this space and 
                      stay up to date on the latest trends. 
                      </p>
                    </div>
                    <ng-template #marketingSocialMediaSecond>
                      <ng-container *ngIf="2 == data?.marketingSocialMedia?.value; else marketingSocialMediaThird">
                        <p>
                        {{data?.busiName}}'s social media helps build awareness and engage existing customers. Great job!
                        Create a way to drive sales, such as setting up a shop on social media, or posting about discounts and promotions. 
                        Check your Action Plan for a resource. 
                        </p>
                      </ng-container>
                    </ng-template>
                    <ng-template #marketingSocialMediaSecond>
                      <ng-container *ngIf="1 == data?.marketingSocialMedia?.value; else marketingSocialMediaFourth">
                        <p>
                        {{data?.busiName}}'s has social media but there is little to no benefit. 
                        Make sure your business is on the right social platform that your Target Market customer is on. 
                        Ex. LinkedIn is a good platform to market to other businesses. 
                        Create a way to engage customers by using applicable hashtags and just create great content! 
                        Here are some <a href="https://www.digitalvidya.com/blog/social-media-dos-and-donts/"
                        target="_blank"  rel="noopener noreferrer">Social Media Do's and Dont's</a>
                      </p>
                      </ng-container>
                    </ng-template>
                    <ng-template #marketingSocialMediaFourth>
                      <p>
                      {{data?.busiName}} doesn't have social media yet. Social media is a good way to engage customers, keep them up to date
                      and drive business sales. When ready, choose the right social platform by researching which platforms your competitors are on, and 
                      making sure your target audience is on the platform. Ex. LinkedIn is a good platform to market to other businesses. 
                      Create a way to engage customers by using applicable hashtags and just create great content! 
                      Here are some <a href="https://www.digitalvidya.com/blog/social-media-dos-and-donts/"
                      target="_blank"  rel="noopener noreferrer">Social Media Do's and Dont's</a>
                     </p>
                    </ng-template> 
                      <!--Customer Service-->
                  <div *ngIf="1 >= data?.customerService?.value; else customerServiceElse">
                    <p>
                    The business needs assistance in customer service. Check your Action Plan for a resource. 
                    </p>
                  </div>
                  <ng-template #customerServiceElse>
                    <p>
                    {{data?.busiName}}'s customer service is in good shape. Great job!
                    </p>
                    </ng-template>
                          <!--Customer Engagment-->
                  <div *ngIf="1 >= data?.customerEngagement?.value; else customerEngagementElse">
                    <p>
                    The business needs assistance in customer engagement. Check your Action Plan for a resource. 
                  </p>
                  </div>
                  <ng-template #customerEngagementElse>
                    <p>
                    {{data?.busiName}}'s customer engagement is in good shape.
                   </p>
                    </ng-template>
                          </div>
                </mat-card-content>
                <mat-divider inset></mat-divider>
                    <mat-card-actions>
                      <button mat-button (click)="marketingOperationsText()">{{ showShortOperationsMarketingDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions>
                  </mat-card>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="teal">
                            {{assessmentPayload?.legalScore?.legalOperatingPercentage*10 | number:'1.0-0'}}/10  
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Legal Operations</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/Legal.png" alt="Legal">
                      </mat-card-title-group>
                      <mat-card-content>
                        <h3 class="teal">How are your legal operations?</h3>
                      <div [ngClass]="{'show-less': showShortLegalDesciption}">
                         <!--Legal Registration-->
                         <div *ngIf="'Not registered' !== data?.busiRegType?.name || 'Sole proprietor' !== data?.busiRegType?.name; else busiRegTypeSoleProp"> 
                          <p>
                          {{data?.busiName}} is registered as a {{data?.busiRegType?.name}}. 
                          </p>
                        </div>
                          <ng-template #busiRegTypeSoleProp>
                            <ng-container *ngIf="'Sole proprietor' == data?.practicalLegalOpAgreement?.name">
                              <p>
                              {{data?.busiName}} is a {{data?.busiRegType?.name}}. Consider registering as an 
                              LLC or as an entity that gives your business liability protection. <a href="https://www.legalzoom.com/articles/llc-vs-sole-proprietorship"
                              target="_blank"  rel="noopener noreferrer">Determine Pros and Cons for Sole Prop Vs. LLC</a>
                              </p>
                            </ng-container>
                          </ng-template>
                          <ng-template #busiRegTypeNotReg>
                            <ng-container *ngIf="'Not registered' == data?.practicalLegalOpAgreement?.name">
                              <p>
                              {{data?.busiName}} is {{data?.busiRegType?.name}}. When ready, consider registering as an 
                              LLC or as an entity that gives your business liability protection. <a href="https://www.legalzoom.com/articles/llc-vs-sole-proprietorship"
                              target="_blank"  rel="noopener noreferrer">Determine Pros and Cons for Sole Prop Vs. LLC</a>. View your 
                              Action Plan for resources. 
                            </p>
                            </ng-container>
                          </ng-template>
                        <!--Legal Operating Agreement-->
                        <div *ngIf="1 == data?.legalOpAgreement?.value; else legalOpAgreementElse"> 
                          <p>
                          {{data?.busiName}} has a solid operating agreement. Great job!
                          </p>
                        </div>
                          <ng-template #legalOpAgreementElse>
                            <ng-container *ngIf="0 == data?.legalOpAgreement?.value">
                              <p>
                              {{data?.busiName}} needs a solid operating agreement. 
                              </p>
                            </ng-container>
                          </ng-template>
                              <!--Legal Disclaimers-->
                          <ng-container *ngIf="'Yes' == data?.legalDisclaimers?.name; else legalDisclaimerssecond">
                            <p>
                            {{data?.busiName}} has solid disclaimers. Great job, make sure to use and enforce them as applicable. 
                            </p>
                          </ng-container>
                            <ng-template #legalDisclaimerssecond>
                              <ng-container *ngIf="'I don’t know if I need them' == data?.legalDisclaimers?.name; else legalDisclaimersThird">
                                <p>
                                {{data?.busiName}} doesn't know if it needs disclaimers. 
                                <a href="https://www.chicagoinnocenceproject.org/business-needs-disclaimers/"
                              target="_blank"  rel="noopener noreferrer">Here is a resource to determine if the business needs disclaimers.</a> 
                             </p>
                            </ng-container>
                            </ng-template>
                            <ng-template #legalDisclaimersThird>
                              <ng-container *ngIf="'No' == data?.legalDisclaimers?.name">
                                <p>
                                {{data?.busiName}} needs solid disclaimers. Depending on what type you need, here is an online resource or contact a lawyer. 
                                <a href="https://smallbiztrends.com/2021/11/disclaimer-examples.html"
                              target="_blank"  rel="noopener noreferrer">Business Disclaimer Examples and Types</a> 
                              </p>
                            </ng-container>
                            </ng-template>
                          <!--Legal IP-->
                          <div *ngIf="0 == data?.legalIP?.value; else legalIPElse">
                            <p>
                            The business {{data?.legalIP?.name}} Check your Action Plan for a resource. 
                            </p>
                          </div>
                          <ng-template #legalIPElse>
                            <p>
                            {{data?.busiName}} {{data?.legalIP?.name}} 
                            </p>
                          </ng-template>
                      </div>
                </mat-card-content>
                    <mat-divider inset></mat-divider>
                    <mat-card-actions>
                        <button mat-button (click)="legalText()">{{ showShortLegalDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions> 
                  </mat-card>
                </div>
              <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                <mat-card class="sfe-card">
                    <mat-card-title-group>
                      <mat-card-title>
                        <h1 class="teal">
                          {{assessmentPayload?.financeOperationsScore?.financeOperationsOperatingPercentage*10 | number:'1.0-0'}}/10 
                        </h1>
                      </mat-card-title>
                      <mat-card-subtitle>Finance & Business Operations</mat-card-subtitle>
                      <img class="card-img-top img-fluid"  src="../../../assets/imgs/Finance.png" alt="Finance">
                    </mat-card-title-group>
                    <mat-card-content>
                      <h3 class="teal">How are your finance and general operations?</h3>
                    <div [ngClass]="{'show-less': showShortFinOpDesciption}">
                      <!--Operations Plan-->
                      <p>
                      {{data?.busiName}} plans to operate in the following manner: {{assessmentPayload?.operationMethodsArray}}.
                        </p>
                      <!--Capital TODO-->  
                        <ng-container *ngIf="'None' == data?.capitalSeeking?.name; else capitalSeekingNotSure">
                          <p>
                          {{data?.busiName}} is not looking for capital.
                          </p>
                        </ng-container>
                          <ng-template #capitalSeekingNotSure>
                            <ng-container *ngIf="'I`m not sure how much' == data?.capitalSeeking?.name; else capitalSeekingAmount">
                           <p>
                              {{data?.busiName}} is looking for capital, but is not sure for how much.
                            </p>
                          </ng-container>
                          </ng-template>
                          <ng-template #capitalSeekingAmount>
                           <p>
                            {{data?.busiName}} is looking for capital in an amount of {{data?.capitalSeeking?.name}}.
                          </p>
                        </ng-template>
                        <!--Payment System-->
                        <ng-container *ngIf="'Yes, and someone on the team (or I) know(s) how to use it' == data?.financePaymentSystem?.name; else financePaymentSystemSecond">
                          <p>
                          {{data?.busiName}} actively uses a payment system and/or has one set up.
                          </p>
                      </ng-container>
                        <ng-template #financePaymentSystemSecond>
                          <ng-container *ngIf="'Yes, but no one on the team (or I) know(s) how to use it' == data?.financePaymentSystem?.name; else financePaymentSystemThird">
                           <p>
                            {{data?.busiName}} uses a payment system and/or has one set up, but needs help using it efficiently. Make sure the business is seperating business cash from personal cash.
                         </p>
                        </ng-container>
                        </ng-template>
                        <ng-template #financePaymentSystemThird>
                          <p>
                          {{data?.busiName}} needs a payment system. Once operations begin, set up a business payment system, to keep business transactions seperate from personal transactions. 
                        </p>
                      </ng-template>
                        <!--Accounting System-->
                        <ng-container *ngIf="'Yes, and someone on the team (or I) know(s) how to use it' == data?.financeAccountingSystem?.name; else financeAccountingSystemsecond">
                        <p>
                          {{data?.busiName}} actively uses an accounting system and/or has one set up. Great job, make sure to review your cash flows monthly, to stay sustainable. 
                        </p>
                      </ng-container>
                        <ng-template #financeAccountingSystemsecond>
                          <ng-container *ngIf="'Yes, but no one on the team (or I) know(s) how to use it' == data?.financeAccountingSystem?.name; else financeAccountingSystemthird">
                            <p>
                            {{data?.busiName}} actively uses an accounting system and/or has one set up, but needs help using it efficiently. Check your Action Plan for a resource.
                            </p>
                          </ng-container>
                        </ng-template>
                        <ng-template #financeAccountingSystemthird>
                          <p>
                          {{data?.busiName}} needs an accounting system. When ready, accounting systems will help you keep track of your money going in and money going out. 
                        It's important to have an accounting system, not just a bank account or payment gateway, so that it will make tax filing easier, give you the ability to run quick reports and 
                         give you quick and easy insights into your financial health. 
                       </p>
                        </ng-template>
                        <!--Operating Procedures-->
                        <div *ngIf=" 2 ==  data?.operatingSOP?.value; else practicalOpSOPelse"> 
                          <p>
                          {{data?.busiName}} has created thorough operating procedures for business continuity. Great job!
                          </p>
                        </div>
                          <ng-template #practicalOpSOPelse>
                            <ng-container *ngIf="1 ==  data?.operatingSOP?.value; else practicalOpSOPNA">
                              <p>
                              {{data?.busiName}} needs standard operating prodcedures to assist with business scalability and continuity. Check your Action Plan for a resource. 
                              </p>
                            </ng-container>
                          </ng-template>
                        <ng-template #practicalOpSOPNA>
                          <p>
                          {{data?.busiName}} doesn't have standard operating procedures (SOPs). If the business plans to scale or hire, SOP's are documents
                          that speak for you, allowing new hires to reference for trainings, creating consistent business operations. 
                          </p>
                        </ng-template>
                        <!--Production Process-->
                        <div *ngIf="data?.operatingProductionProcess?.value == 2; else opProductionProcessSecond">
                          <p>
                          {{data?.busiName}} has a consistent and stable production process. Great job! Remember to let your customers know. 
                          </p>
                        </div>
                          <ng-template #opProductionProcessSecond>
                            <ng-container *ngIf="data?.operatingProductionProcess?.value == 1; else opProductionProcessThird">
                              <p>
                              {{data?.busiName}} needs to create a consistent and/or stable production process. This allows 
                          quality guarantees, and reliability for your customers.
                          </p> 
                            </ng-container>
                          </ng-template> 
                          <ng-template #opProductionProcessThird>
                            <ng-container *ngIf="data?.operatingProductionProcess?.value == 1">
                            <p>
                              {{data?.busiName}} hasn't identified a stable and consistent production process. Check your Action Plan for a resource. 
                            </p>
                          </ng-container>
                          </ng-template> 
                    </div>
              </mat-card-content>
              <mat-divider inset></mat-divider>
                  <mat-card-actions>
                    <button mat-button (click)="finOpText()">{{ showShortFinOpDesciption ? 'READ MORE': 'READ LESS' }}</button>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="purple-txt">
                            {{assessmentPayload?.teamExecutionScore?.teamExecutionPercentage*10 | number:'1.0-0'}}/10  
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Team Execution</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/HR.png" alt="HR">
                      </mat-card-title-group>
                      <mat-card-content>
                        <h3 class="purple-txt">How are your team's hard skills?</h3>
                      <div [ngClass]="{'show-less': showShortTeamOperationsDesciption}">
                        <!--Team Roles-->
                        <div >
                          <p>The team has a team of {{data?.teamMembersQuan}} who have expertise in {{assessmentPayload?.teamRole?.teamRoleNameArray}}. 
                            These roles can be essential to build a successful business. <b>It may be helpful to enlist these roles as
                            additional members where needed, as capacity thins or opportunities expand</b>: {{assessmentPayload?.teamRole?.teamToGetNameArray}}
                          </p>
                        </div>
                        <!--Business Management Experience -->
                        <div>
                          <div *ngIf="data?.teamLeaderSerialEntrp?.name === 'Yes'; else teamLeaderSerialEntrpElse">
                            <p>  It's great the core team has business management experience! 
                            </p>
                          </div>
                          <ng-template #teamLeaderSerialEntrpElse>
                            <p>If no one on the team has entrepreneurial experience, that's no problem! 
                              It could help to <b>find someone who has entrepreneurial experience, such as a mentor in your industry</b>, 
                              incubators, development centers or business consultants. They can advise 
                              the leader and company on hurdles as an entrepreneur. 
                            </p>
                          </ng-template>
                        </div>
                        <div *ngIf="data?.hiring?.name == 'Yes'">
                        <p>
                          {{data?.busiName}} wants to hire. Check your Action Plan for resources.  
                        </p>
                        </div>
                        <div *ngIf="2 > data?.teamMembersQuan">
                          <p>If {{data?.busiName}} isn't in a place to hire, it can <b>expand capacity 
                            through interns and independent contractors</b>. Many colleges allow you to post listings on platforms 
                            such as <a href="https://app.joinhandshake.com/" target="_blank" rel="noopener noreferrer">Handshake</a>. To read about intern laws, 
                            read this one pager on the <a href="https://www.dol.gov/sites/dolgov/files/WHD/legacy/files/whdfs71.pdf" target="_blank" rel="noopener noreferrer">
                            Fair Labor Standards Act. </a> 
                          </p>
                        </div>
                        <!--Company Culture Strategies-->
                        <div *ngIf="assessmentPayload?.hrRetention?.hrRetentionNameArray.length > 0">
                          <p>
                          {{data?.busiName}} currently fosters company culture and employee retention through the following activities: {{assessmentPayload?.hrRetention?.hrRetentionNameArray}}. 
                        </p>
                        </div>
                      
                      <!--Hiring Retention-->
                <div *ngIf="2 >= assessmentPayload?.hrRetention?.hrRetentionScore">
                <p>
                  The business should identify more ways to increase employee retention. Good and diverse retention strategies keep HR costs low, saves management time 
                  and keeps the team motivated.
                </p>
                </div>
                        <!--Hiring Needs Work-->
                <div *ngIf="assessmentPayload?.hiringWorkOnNameArray?.length > 0; elsehiringElse">
                   <p>
                  {{data?.busiName}} needs assistance in the following hiring practices: {{assessmentPayload?.hiringWorkOnNameArray}}. 
                    </p>
                  </div>
                <ng-template #elsehiringElse>
                <p>
                  {{data?.busiName}} is comfortable with their hiring process.
                </p>
                </ng-template>
                    <!--Team Time-->
                    <div>
                      <div *ngIf="2 >= data?.teamTime?.value ; else teamTimeElse">
                        <p>The amount of time that the average team member 
                          has to devote is {{data?.teamTime?.name}}, with a total of {{data?.teamMembersQuan}} team member(s). 
                          It can make a productive difference if at least one team member decides to work full-time.</p>
                      </div>
                      <ng-template #teamTimeElse>
                        <p>The amount of time that the average team member 
                          has to devote is {{teamTime?.name}}, with a total of {{data?.teamMembersQuan}} team member(s).
                         This is good, and can help the team achieve it’s goals much faster than not. <b>Enlist processes 
                         to scale the team, such as operations manuals, here are 
                         <a href="https://www.sampletemplates.com/business-templates/operation-manual.html" target="_blank" rel="noopener noreferrer"> 7 Free Operations Templates. </a>
                         And implement or review HR practices</b>. 
                        </p>
                      </ng-template>
                    </div>
                    <!--Team Network-->
                    <div>
                      <div *ngIf="2 >= data?.teamNetwork?.value; else teamNetworkElse">
                        <p>Your ability to attract customers and/or develop {{data?.busiName}} through your current
                          network was rated as '{{data?.teamNetwork?.name}}. <b>Expand your network by
                           attending networking events, using <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>, asking your existing network for introductions, etc. </b></p>
                      </div>
                      <ng-template #teamNetworkElse>
                        <p>Your ability to attract customers and/or develop {{data?.busiName}} through your current
                          network was rated as '{{data?.teamNetwork?.name}}. This is a strength, saving you time,
                          energy, and providing a competitive advantage.  <b>Reach out to your network to continue to build connections
                          and grow</b>. Here are <a href="https://www.themuse.com/advice/4-email-templates-to-make-networking-way-less-awkward" target="_blank" rel="noopener noreferrer">4 Networking Email Templates</a> to get started. 
                        </p>
                      </ng-template>
                    </div>
                    <!--Industry Knowledge-->
                    <div>
                      <div *ngIf="data?.teamIndustryKnowledge?.value  >= 3 ; else teamIndustryKnowledgeElse">
                        <p>The team knows the {{data?.offerIndustry?.name}} industry on a '{{data?.teamIndustryKnowledge?.name}}' level. This is good! <b>To
                          stay competitive, continue to learn, take courses and/or obtain further
                          certifications</b>. <a href="https://www.edx.org/" target="_blank" rel="noopener noreferrer">edX</a> and <a href="https://www.coursera.org/" target="_blank" rel="noopener noreferrer">Coursera</a> offer free online classess in some areas. 
                      </p>
                    </div>
                      <ng-template #teamIndustryKnowledgeElse>
                        <p>The team knows the {{data?.offerIndustry?.name}} industry on a '{{data?.teamIndustryKnowledge?.name}}' level. 
                          <b>Add a team member with greater knowledge in order to gain a competitive advantages against
                          competition.</b>
                        </p>
                      </ng-template>
                    </div>
                  </div>
                </mat-card-content>
                    <mat-divider inset></mat-divider>
                    <mat-card-actions>
                      <button mat-button (click)="teamOperationsText()">{{ showShortTeamOperationsDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions>
                  </mat-card>
                </div>
            
                <div class="col-lg-4 col-md-4 col-sm-12 sfe-col-spacer">
                  <mat-card class="sfe-card">
                      <mat-card-title-group>
                        <mat-card-title>
                          <h1 class="purple-txt">
                            {{assessmentPayload?.teamDynamicsScore?.teamDynamicsPercentage*10 | number:'1.0-0'}}/10  
                          </h1>
                        </mat-card-title>
                        <mat-card-subtitle>Team Dynamics</mat-card-subtitle>
                        <img class="card-img-top img-fluid"  src="../../../assets/imgs/Operations.png" alt="Operations">
                      </mat-card-title-group>
                      <mat-card-content>
                        <h3 class="purple-txt">How are your team's soft skills? </h3>
                      <div [ngClass]="{'show-less': showShortTeamDynamicDesciption}">
                        <!--Team Time Management-->
                        <div *ngIf="2 >= data?.teamTimeManage?.value; else teamTimeManageElse">
                          <br>
                          <p>The team’s ability to set, prioritize, track and meet goals when given a timeline was rated as
                        '{{data?.teamTimeManage?.name}}'. <b>Check out the <a
                              href="https://youtu.be/1-SvuFIQjK8" target="_blank">SMART Goal Setting method</a> to improve this</b>. Here is a <a
                              href="https://www.smartsheet.com/file/smart-goals-template.docx" target="_blank">downloadable SMART
                              Goals Template</a>. In addition, tools such as your <a
                              href="https://sustainibleapi.web.app/action-plan" target="_blank">Sustainible Action Plan</a> can help prioritize, track and manage
                            these goals and action plans. 
                          </p>
                        </div>
                        <ng-template #teamTimeManageElse>
                          <p> The team’s ability to set, prioritize, track and meet goals when given a timeline was rated as '{{data?.teamTimeManage?.name}}'.
                            Great job! <b>Automate the process</b>: <a href="https://asana.com/" target="_blank">Asana</a> and 
                            <a href="https://trello.com/en-US" target="_blank">Trello</a> are online team management tools that have free versions.
                          </p>
                        </ng-template>
                        <!--Team Unproductivity-->
                        <div *ngIf="2 > data?.teamUnproductivity?.value > 2; else teamUnproductivityElse">
                          <p>The team {{data?.teamUnproductivity?.name}} encounters disfunctionality. This is good - team
                            dysfunctionality can make or break a business. </p>
                        </div>
                        <ng-template #teamUnproductivityElse>
                          <p> The team {{data?.teamUnproductivity?.name}} encounters disfunctionality.
                            Team dysfunctionality can make or break a business.
                            This article by Medium addresses common problems and suggests <a
                              href="https://medium.com/taskworld-blog/lencionis-5-dysfunctions-of-a-team-330d58b2cd81"
                              target="_blank"> solutions to overcome team dysfunction.</a></p>
                        </ng-template>
                        <!--Team Passion-->
                        <div *ngIf="3 >= data?.teamPassion?.value; else teamPassionElse">
                          <p>  The team is '{{data?.teamPassion?.name}}' about the business.
                            The entrepreneurial journey can come with road bumps, passion is 
                            something to depend on. <b>Give it some thought, there may be ways to 
                            weave your passion into your business or vice versa</b>.
                          </p>
                        </div>
                        <ng-template #teamPassionElse>
                          <p>The team is '{{data?.teamPassion?.name}}' about the business. 
                            <b>Share your passion with your customer(s) to get them excited about your business too!</b> 
                            Some ideas are creating blogs, newsletters, content creation, speaking events, etc. 
                          </p>
                        </ng-template>
                        <!--Team Work Life-->
                        <div *ngIf="2 >= data?.teamWorkLife?.value; else teamWorkLifeElse">
                          <p>  The team has a {{data?.teamWorkLife?.name}} work life balance.
                            <b>Create a better work life balance to avoid burnout.</b>.
                          </p>
                        </div>
                        <ng-template #teamWorkLifeElse>
                          <p>The team has a {{data?.teamWorkLife?.name}} work life balance. Great job!
                          </p>
                        </ng-template>
                      </div>
                </mat-card-content>
                
                    <mat-divider inset></mat-divider>
                    <mat-card-actions>
                        <button mat-button (click)="teamDynamicsText()">{{ showShortTeamDynamicDesciption ? 'READ MORE': 'READ LESS' }}</button>
                    </mat-card-actions> 
                    
                  </mat-card>
                </div>
              </div>
            </div>
      </article>
   </div>  
  </div>
</section>

